module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/feature02-fca3f84093d574a58d7d94e9775f2af0.svg";